/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	wrapper: {
		paddingBlock: token('space.025', '2px'),
		paddingInline: token('space.300', '24px'),
	},
	innerWrapper: {
		minHeight: '276px',
	},
});

export default function Loading() {
	return (
		<Box testId="share-to-slack-loading" xcss={styles.wrapper}>
			<Inline alignBlock="center" alignInline="center" xcss={styles.innerWrapper}>
				<Spinner size="large" />
			</Inline>
		</Box>
	);
}
